export const isAuthenticated = () => {
  if (localStorage.getItem("userToken")) {
    return localStorage.getItem("userToken");
  }
  return false;
};
